class GrowRating { 
	constructor() { 
		this.ratingTargets = document.querySelectorAll('.star__ratings .click__target');
		this.ratingProgress = document.querySelector('.star__ratings .ratings__bar');
	}


	setRating(rating) { 
		const id = this.ratingProgress.dataset.id;
		const data = {}
		data.postid = id
		data.rating = rating
		updateRatings( data )
	}

	isValid() { 
		let valid = true
		if (window.sessionStorage.getItem('grow_rating')) {
			const ratingSession = JSON.parse(window.sessionStorage.getItem('grow_rating'))
			if (ratingSession[this.ratingProgress.dataset.id]) {
				// document.querySelector('.star__ratings').classList.add('loading')
				valid = false
			}
		}
		return valid
	}

	setHover() {
		
		this.ratingTargets.forEach((target) => {
			target.addEventListener('mouseover', (e) => {
				if (!this.isValid()) return
				this.ratingProgress.style.width = e.target.dataset.rating * 20 + '%';
			})
			target.addEventListener('mouseleave', (e) => {
				if (!this.isValid()) return
				this.ratingProgress.style.width =this.ratingProgress.dataset.width;
			})
			target.addEventListener('click', (e) => {
				if (!this.isValid()) return
				this.ratingProgress.dataset.width = e.target.dataset.rating * 20 + '%';
				this.setRating(e.target.dataset.rating)
			})
		 })
	}
}

document.addEventListener('DOMContentLoaded', () => { 
	if(document.querySelector('.star__ratings')) {
		const growRating = new GrowRating();
		growRating.setHover()
	}
})